__turbopack_context__.v({
  "destinationName": "TopDestinationCard-module-scss-module__p1ohYa__destinationName",
  "fallback": "TopDestinationCard-module-scss-module__p1ohYa__fallback",
  "gradiant": "TopDestinationCard-module-scss-module__p1ohYa__gradiant",
  "image": "TopDestinationCard-module-scss-module__p1ohYa__image",
  "imageHidden": "TopDestinationCard-module-scss-module__p1ohYa__imageHidden",
  "orangeBar": "TopDestinationCard-module-scss-module__p1ohYa__orangeBar",
  "overlay": "TopDestinationCard-module-scss-module__p1ohYa__overlay",
  "root": "TopDestinationCard-module-scss-module__p1ohYa__root",
});
